import { SettingConst } from '@faire/web-api--source/types';

/**
 * Control when retailers receive the cart building and savings guide experiment
 * https://www.notion.so/faire/Cart-Building-and-Savings-Guide-1f92efb5c25a81f8919cfcc5270dbc7f?pvs=4
 */
export const IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715 =
  'IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715' as SettingConst<
    'IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250715',
    boolean,
    'RETAILER_ANDROID' | 'RETAILER_IOS' | 'RETAILER' | 'HOTJAR_RETAILER'
  >;
